import { render, staticRenderFns } from "./paMonitor.vue?vue&type=template&id=2d56196c&scoped=true&lang=pug"
import script from "./paMonitor.vue?vue&type=script&lang=js"
export * from "./paMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d56196c",
  null
  
)

/* custom blocks */
import block0 from "./paMonitor.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports